import { Cell, CellContent, CellLinkAction } from '@kcd/design-system';

type Props = {
  onClick: () => void;
  title: string | React.ReactNode;
};

export function MypageCell({ onClick, title }: Props) {
  return (
    <Cell
      as="button"
      className="!border-b !border-screen-02 last:!border-0"
      onClick={onClick}
    >
      <CellContent title={<div className="flex items-center">{title}</div>} />
      <CellLinkAction />
    </Cell>
  );
}
